import React from 'react'
import { CFormSelect } from '@coreui/react'
import Select from 'react-select'

const ProductInfoSection = ({
  inputList,
  productMixList,
  spreadChargeRates,
  quantityType,
  skuLocation,
  orderTypeName,
  xeroItemCodeStatus,
  mixCodeValue,
  mixSkuValue,
  priceLoaded,
  errorList,
  onFieldChange,
  onTonsKeyUp,
  onTonsBlur,
  onProductMixChange,
  onAddProduct,
  onRemoveProduct,
  onQuantityChange,
  onSpreadRateChange,
  onQuantityTotal,
  onQuantityTotalBlur,
  onPercentatgeCalcBlur,
  onEnableMix,
  onEnableQuantity,
  onAddDocket,
  onRemoveDocket,
  onFileChange,
}) => {
  const groups = inputList.product_information || []

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <h4>
          Product Information
          {Number(inputList.order_type) > 0 && orderTypeName && (
            <span className="text-muted"> – ({orderTypeName})</span>
          )}
        </h4>
      </div>

      <div className="row mb-3">
        <div className="col-lg-3">
          <label>Custom Spread Rate</label>
          <input
            className="form-control"
            name="custom_spread_rate"
            type="text"
            value={inputList.custom_spread_rate || ''}
            onChange={onFieldChange}
          />
          <div className="text-danger">{errorList['custom_spread_rate']}</div>
        </div>
        <div className="col-lg-3">
          <label>Tons Ordered</label>
          <input
            className="form-control"
            name="tons_ordered"
            type="number"
            value={inputList.tons_ordered || ''}
            disabled
            onKeyUp={onTonsKeyUp}
            onChange={onFieldChange}
            onBlur={onTonsBlur}
          />
          <div className="text-danger">{errorList['tons_ordered']}</div>
        </div>
        <div className="col-lg-3">
          <label>Tons Actual</label>
          <input
            className="form-control"
            name="tons_actual"
            type="text"
            value={Number(inputList.tons_actual || 0).toFixed(3)}
            disabled
          />
          <div className="text-danger">{errorList['tons_actual']}</div>
        </div>
      </div>

      {groups.map((group, gi) => {
        const products = group.order_list_products || []
        const filtered = products.filter((p) => p.product_name !== 'FRE' && !p.is_dummy)
        const dockets = group.docket_numbers || []

        return (
          <div key={gi} className="mb-5">
            <div className="row mb-3">
              <div className="col-lg-5 d-flex align-items-end">
                <div className="flex-grow-1">
                  <label>Product Code</label>
                  <Select
                    name="product_id"
                    options={productMixList}
                    value={productMixList.find((o) => o.value === group.product_id) || null}
                    onChange={(opt) => onProductMixChange(opt, gi)}
                    placeholder="Select Product…"
                  />
                  <div className="text-danger">
                    {errorList[`product_information.${gi}.product_mix_id`]}
                  </div>
                </div>
                <button
                  className="btn btn-success ms-3"
                  onClick={(e) => onAddProduct(e, gi)}
                  disabled={priceLoaded}
                >
                  Add Product
                </button>
              </div>
            </div>

            {filtered.length > 0 && (
              <>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#ID</th>
                      <th>Product Name</th>
                      <th
                        onClick={filtered.length > 1 ? onEnableQuantity : undefined}
                        style={{ cursor: filtered.length > 1 ? 'pointer' : 'default' }}
                      >
                        Quantity
                      </th>
                      {filtered.length > 1 && (
                        <th onClick={onEnableMix} style={{ cursor: 'pointer' }}>
                          Mix %
                        </th>
                      )}
                      <th>Quantity Type</th>
                      {filtered.length > 0 && <th>Total Quantity</th>}
                      <th>Xero Code</th>
                      <th>Unit Price</th>
                      <th>Spread Charge Rate</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((prod, pi) => (
                      <tr key={pi}>
                        <td>{prod.product_mix_id}</td>
                        <td>{prod.product_name}</td>
                        <td>
                          <input
                            className="form-control"
                            name="quantity"
                            type="number"
                            value={prod.quantity}
                            onChange={(e) =>
                              onQuantityChange(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                            }
                            onBlur={(e) =>
                              onQuantityTotalBlur(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                            }
                            onKeyUp={(e) =>
                              onQuantityTotal(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                            }
                          />
                        </td>
                        {filtered.length > 1 && (
                          <td>
                            <input
                              className="form-control"
                              name="mix_percentage"
                              value={prod.mix_percentage}
                              disabled
                              onChange={(e) =>
                                onQuantityChange(
                                  e,
                                  gi,
                                  pi,
                                  'product_information',
                                  'order_list_products',
                                )
                              }
                              onBlur={(e) =>
                                onPercentatgeCalcBlur(
                                  e,
                                  gi,
                                  pi,
                                  'product_information',
                                  'order_list_products',
                                )
                              }
                              onKeyUp={(e) => onTonsKeyUp(e, gi, pi)}
                            />
                          </td>
                        )}
                        <td>
                          <CFormSelect
                            name="quantity_type"
                            value={prod.quantity_type}
                            onChange={(e) =>
                              onSpreadRateChange(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                            }
                            onBlur={(e) =>
                              onQuantityTotal(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                            }
                            disabled={priceLoaded}
                          >
                            <option value="0">— select —</option>
                            {quantityType.map((q) => (
                              <option key={q.id} value={q.id}>
                                {q.name}
                              </option>
                            ))}
                          </CFormSelect>
                        </td>
                        <td>
                          <CFormSelect name="total_quantity" value={prod.quantity_type} disabled>
                            <option value="0">— select —</option>
                            {quantityType.map((item) => (
                              <option key={item.id} value={item.id}>
                                {(Number(prod.quantity) * item.quantity_value).toFixed(3)}
                              </option>
                            ))}
                          </CFormSelect>
                        </td>
                        <td>
                          <input
                            disabled
                            className={
                              prod.is_customer_product === 1
                                ? 'form-control'
                                : prod.xero_code === 'N/A' || prod.unit_price === 'N/A'
                                ? 'form-control text-danger border-danger'
                                : 'form-control'
                            }
                            type="text"
                            name="xero_code"
                            value={prod.is_customer_product === 1 ? '-' : prod.xero_code}
                          />
                        </td>
                        <td>
                          <input
                            className={
                              prod.is_customer_product === 1
                                ? 'form-control'
                                : prod.unit_price === 'N/A'
                                ? 'form-control text-danger'
                                : 'form-control'
                            }
                            type="text"
                            name="unit_price"
                            value={prod.unit_price}
                            disabled={priceLoaded}
                            onChange={(e) =>
                              onQuantityChange(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                            }
                          />
                          <span className="text-danger">
                            {
                              errorList[
                                `product_information.${gi}.order_list_products.${pi}.unit_price`
                              ]
                            }
                          </span>
                        </td>
                        <td>
                          {prod.product_name === 'FRE' ||
                          inputList.has_spread_charge_rate === '0' ? (
                            'N/A'
                          ) : (
                            <CFormSelect
                              name="spread_charge_rate"
                              value={prod.spread_charge_rate}
                              onChange={(e) =>
                                onSpreadRateChange(
                                  e,
                                  gi,
                                  pi,
                                  'product_information',
                                  'order_list_products',
                                )
                              }
                              disabled={prod.is_customer_product === 1 || priceLoaded}
                            >
                              <option value="0">— select —</option>
                              {spreadChargeRates.map((sc) => (
                                <option key={sc.id} value={sc.id}>
                                  {sc.name}
                                </option>
                              ))}
                            </CFormSelect>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-danger"
                            onClick={(e) => {
                              onRemoveProduct(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                              onQuantityTotal(
                                e,
                                gi,
                                pi,
                                'product_information',
                                'order_list_products',
                              )
                            }}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {filtered.length > 1 && (
                  <div className="row mb-3">
                    <div className="col-lg-2">
                      <label>Mix SKU</label>
                      <input className="form-control" type="text" value={mixCodeValue} disabled />
                    </div>
                    <div className="col-lg-2">
                      <label>Mix Price</label>
                      <input className="form-control" type="text" value={mixSkuValue} disabled />
                    </div>
                  </div>
                )}
              </>
            )}

            {/* Docket section remains unchanged */}
            <div className="d-flex align-items-center mt-4 mb-3">
              <h5 className="me-3">Docket List</h5>
              <button className="btn btn-success" onClick={(e) => onAddDocket(e, gi)}>
                Add Docket
              </button>
            </div>

            {dockets.map((dock, di) => (
              <div key={dock.id ?? di} className="row my-2">
                <div className="col-lg-1">
                  <input
                    className="form-control"
                    name="docket_number"
                    type="text"
                    placeholder="Docket Number"
                    value={dock.docket_number}
                    onChange={(e) =>
                      onQuantityChange(e, gi, di, 'product_information', 'docket_numbers')
                    }
                  />
                </div>
                <div className="col-lg-2">
                  <input
                    className="form-control"
                    name="docket_date"
                    type="date"
                    value={dock.docket_date}
                    onChange={(e) =>
                      onQuantityChange(e, gi, di, 'product_information', 'docket_numbers')
                    }
                  />
                </div>
                <div className="col-lg-2">
                  <CFormSelect
                    name="sku_location"
                    value={dock.sku_location || 0}
                    onChange={(e) =>
                      onQuantityChange(e, gi, di, 'product_information', 'docket_numbers')
                    }
                  >
                    <option value={0}>— select —</option>
                    {skuLocation.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.name}
                      </option>
                    ))}
                  </CFormSelect>
                </div>
                <div className="col-lg-2">
                  <input
                    className="form-control"
                    name="weight"
                    type="number"
                    placeholder="Weight"
                    value={dock.weight}
                    onChange={(e) =>
                      onQuantityChange(e, gi, di, 'product_information', 'docket_numbers')
                    }
                  />
                </div>
                <div className="col-lg-2">
                  <input
                    className="form-control"
                    onChange={(e) => onFileChange(e, gi, di)}
                    type="file"
                    name="imageURL"
                  />
                  <input type="hidden" name="imageName" value={dock.imageName || ''} />
                  <span className="text-danger">{errorList.image}</span>
                </div>
                <div className="col-lg-2">
                  {dock.imageURL && dock.imageName && (
                    <label className="pb-2">
                      Preview:
                      <br />
                      <a href={dock.imageURL} target="_blank" rel="noreferrer">
                        {dock.imageName}
                      </a>
                    </label>
                  )}
                </div>
                <div className="col-lg-1">
                  <button
                    className="btn btn-danger"
                    onClick={(e) =>
                      onRemoveDocket(e, di, gi, 'product_information', 'docket_numbers')
                    }
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )
      })}
    </>
  )
}

export default ProductInfoSection
